import extent from './extend';

const exists = function(arr, val) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === val) {
            return true;
        }
    }
    return false;
};

const ext =  {
    
    on: function(eventName, handler) {
        this.$events = this.$events || {};
        var arr = this.$events[eventName] = this.$events[eventName] || [];
        if (handler && !exists(arr, handler)) {
            arr.push(handler);
        }
    },

    off: function(eventName, handler) {
        this.$events = this.$events || {};
        if (this.$events[eventName]) {
            if (!handler) {
                delete this.$events[eventName];
            }
            else {
                var arr = this.$events[eventName];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i] === handler) {
                        arr.splice(i, 1);
                        break;
                    }
                }
            }
        }
        
    },

    $emit: function(eventName, e) {
        this.$events = this.$events || {};
        let arr = this.$events[eventName];
        if (arr && arr.length) {
            e.sender = this;
            for (let i = 0; i < arr.length; i++) {
                if (!e.handled) {
                    arr[i].apply(this, [e]);
                }
            }
        }
    }

};

export default {
    install: function(target) {
        extent(target, ext);
    }
};
